var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTokenHolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-token-holder_svg__clip0_1601_8783)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#26A17B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.8 5.2H8m3.2 0H8m0 0v6.4",
    stroke: "#fff",
    strokeWidth: 1.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-token-holder_svg__clip0_1601_8783"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBjbGlwLXBhdGg9InVybCgjY2xpcDBfMTYwMV84NzgzKSI+CiAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiByeD0iOCIgZmlsbD0iIzI2QTE3QiIvPgogIDxwYXRoIGQ9Ik00LjgwMDc4IDUuMTk5MjJIOC4wMDA3OE0xMS4yMDA4IDUuMTk5MjJIOC4wMDA3OE04LjAwMDc4IDUuMTk5MjJWMTEuNTk5MiIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIxLjYiLz4KICA8L2c+CiAgPGRlZnM+CiAgPGNsaXBQYXRoIGlkPSJjbGlwMF8xNjAxXzg3ODMiPgogIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0id2hpdGUiLz4KICA8L2NsaXBQYXRoPgogIDwvZGVmcz4KICA8L3N2Zz4KICA=";
export { SvgIconTokenHolder as ReactComponent };